import api from './api';

export const reportService = {
  /**
   * Search benefit history with filters.
   */
  searchBenefitHistory: async (searchParams) => {
    const response = await api.post('/reports/benefit-history', searchParams);
    return response.data;
  },
};